import { useEffect, useState } from 'react';

interface VersaoInfo {
  versao: string;
  commit: string | null;
  data: string | null;
}

/**
 * Versao da release no ar (carimbo do deploy.js), de `/api/version` (publico). Devolve null em dev
 * (o backend responde 'dev') e enquanto carrega — quem usa so renderiza quando tem valor.
 * Hook separado porque quem cobre o rodape da pagina (modal em tela cheia) precisa exibir a versao
 * por conta propria — ver ModalFinalizarVenda.
 */
export function useVersao(): VersaoInfo | null {
  const [info, setInfo] = useState<VersaoInfo | null>(null);

  useEffect(() => {
    let vivo = true;
    fetch('/api/version')
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => vivo && d && setInfo(d))
      .catch(() => {});
    return () => {
      vivo = false;
    };
  }, []);

  return info && info.versao && info.versao !== 'dev' ? info : null;
}

/** Detalhe pro hover (title): commit + data, pra rastrear a release exata. */
export function detalheVersao(info: VersaoInfo): string {
  return [info.commit && `commit ${info.commit}`, info.data].filter(Boolean).join(' · ');
}

/** Rodape discreto com a versao da release no ar. */
export function RodapeVersao() {
  const info = useVersao();
  if (!info) return null;

  const detalhe = detalheVersao(info);

  return (
    <footer className="app-versao" title={detalhe || undefined}>
      FIODECOBRE <span className="app-versao-num">{info.versao}</span>
    </footer>
  );
}
